import { IBaseParams } from '@interfaces/IBaseParam';
import { IBaseResponse } from '@interfaces/IBaseResponse';
import { useMutation, useQuery } from 'react-query';
import {
  deleteTahunAjaranFromAPI,
  getAcademicActiveFromAPI,
  getListSemesterFromAPI,
  getListTahunAjaranFromAPI,
  getSemesterActiveFromAPI,
  postTahunAjaranFromAPI,
  setDefaultSemesterFromAPI,
  setDefaultTahunAjaranFromAPI,
  updateTahunAjaranFromAPI,
} from './tahunajaran.api';
import {
  IParamTahunAjaran,
  ISemester,
  ITahunAjaran,
} from './tahunajaran.types';

export const actionGetListTahunAjaran = (params: IBaseParams) =>
  useQuery({
    queryKey: ['actionGetListTahunAjaran', params],
    queryFn: () => getListTahunAjaranFromAPI(params),
    select: (res) => (res?.data as IBaseResponse<ITahunAjaran[]>) ?? null,
  });
export const actionGetAcademicYearActive = (isEnabled?: boolean) =>
  useQuery({
    queryKey: ['actionGetAcademicYearActive'],
    queryFn: () => getAcademicActiveFromAPI(),
    select: (res) => (res?.data?.data as ITahunAjaran) ?? null,
    enabled: isEnabled,
  });

export const actionPostTahunAjaran = () =>
  useMutation((payload: IParamTahunAjaran) => postTahunAjaranFromAPI(payload));

export const actionUpdateTahunAjaran = (id: number) =>
  useMutation((params: IParamTahunAjaran) =>
    updateTahunAjaranFromAPI(id, params),
  );

export const actionDeleteTahunAjaran = () =>
  useMutation((id: number) => deleteTahunAjaranFromAPI(id));

export const actionSetDefaultTahunAjaran = () =>
  useMutation((id: number) => setDefaultTahunAjaranFromAPI(id));

export const actionSetDefaultSemester = () =>
  useMutation((id: number) => setDefaultSemesterFromAPI(id));

export const actionGetSemester = (params: IBaseParams) =>
  useQuery({
    queryKey: ['actionGetSemester', params],
    queryFn: () => getListSemesterFromAPI(params),
    select: (res) => (res?.data as IBaseResponse<ISemester[]>) ?? null,
  });

export const actionGetSemesterActive = (isEnabled?: boolean) =>
  useQuery({
    queryKey: ['actionGetSemesterActive'],
    queryFn: () => getSemesterActiveFromAPI(),
    select: (res) => (res?.data?.data as ISemester) ?? null,
    enabled: isEnabled,
  });
